import { checkInCheckOutShopper } from "./ApiEndPoint.tsx";
import { baseApiCall } from "./BaseApiCall.tsx";

type ClientGroup = "MM" | "BLOOMS" | "ALDI";

const getApiBaseUrl = (clientGroup: ClientGroup): string => {
  // switch (clientGroup) {
  //   case "MM":
  //     return "https://www.complyco.com.au/";
  //   case "BLOOMS":
  //     return "https://blooms.complyco.com.au/";
  //   case "ALDI":
  //     return "https://aldi.complyco.com.au/";
  //   default:
  //     return "https://www.complyco.com.au/";
  // }
  switch (clientGroup) {
    case "MM":
      return `${process.env.REACT_APP_API_COMMON}`;
    case "BLOOMS":
      return `${process.env.REACT_APP_API_BLOOMS}`;
    case "ALDI":
      return `${process.env.REACT_APP_API_ALDI}`;
    default:
      return `${process.env.REACT_APP_API_COMMON}`;
  }
};

const getApiVersionUrl = (clientGroup: ClientGroup): string => {
  return `${getApiBaseUrl(clientGroup)}api/v1`;
};

// Example: getQuizQuestions for a given client group
export const ApiGetQuizQuestions = (clientGroup: ClientGroup) => {
  const baseUrl = getApiBaseUrl(clientGroup);
  const url = `${baseUrl}report/quiz/get-quiz-question`;

  return baseApiCall({
    url,
    method: "get",
  });
};

export const ApiCallCreateReport = (data: any, clientGroup: any) => {
  const baseUrl = getApiBaseUrl(clientGroup);
  const url = `${baseUrl}api/v1/report/create-report`;

  return baseApiCall({
    url: url,
    method: "post",
    data,
  });
};

export const ApiCallGetReportDetails = (data: any, clientGroup: any) => {
  const baseUrl = getApiBaseUrl(clientGroup);
  const url = `${baseUrl}api/v1/report/report-details${data}`;
  return baseApiCall({
    url: url,
    method: "get",
  });
};

export const ApiScoreCardStep1 = (data: any, clientGroup: any) => {
  const baseUrl = getApiBaseUrl(clientGroup);
  const url = `${baseUrl}api/v1/report/submit-scorecard`;
  return baseApiCall({
    url: url,
    method: "post",
    data,
  });
};

export const ApiScoreCardStep2 = (data: any, clientGroup: any) => {
  const baseUrl = getApiBaseUrl(clientGroup);
  const url = `${baseUrl}api/v1/report/submit-scorecard-questions`;
  return baseApiCall({
    url: url,
    method: "post",
    data,
  });
};

export const ApiScoreCardStep3 = (data: any, clientGroup: any) => {
  const baseUrl = getApiBaseUrl(clientGroup);
  const url = `${baseUrl}api/v1/report/submit-scorecard-invoice-location`;
  return baseApiCall({
    url: url,
    method: "post",
    data,
  });
};

export const ApiCheckInCheckOutShopper = (data: any, clientGroup: any) => {
  const baseUrl = getApiBaseUrl(clientGroup);
  const url = `${baseUrl}api/v1/report/checkIn-checkOut-shopper`;
  return baseApiCall({
    url: url,
    method: 'post',
    data
  })
}

export const ApiDeleteReportPhotos  = (data: any, clientGroup: any) => {
  const baseUrl = getApiBaseUrl(clientGroup);
  const url = `${baseUrl}api/v1/report/delete-report-photo`;
  return baseApiCall({
    url: url,
    method: 'delete',
    data
  })
}
export const ApiUpdateReportVenue  = (data: any, clientGroup: any) => {
  const baseUrl = getApiBaseUrl(clientGroup);
  const url = `${baseUrl}api/v1/report/update-report-venue`;
  return baseApiCall({
    url: url,
    method: 'put',
    data
  })
}
export const ApiUpdateReportBriefJson  = (data: any, clientGroup: any) => {
  const baseUrl = getApiBaseUrl(clientGroup);
  const url = `${baseUrl}api/v1/report/update-report-brief-json`;
  return baseApiCall({
    url: url,
    method: 'put',
    data
  })
}
export const ApiUpdateAddOnQuestion  = (data: any, clientGroup: any) => {
  const baseUrl = getApiBaseUrl(clientGroup);
  const url = `${baseUrl}api/v1/report/update-add-on-questions`;
  return baseApiCall({
    url: url,
    method: 'put',
    data
  })
}
export const ApiUpdateReportQuestion  = (data: any, clientGroup: any) => {
  const baseUrl = getApiBaseUrl(clientGroup);
  const url = `${baseUrl}api/v1/report/update-report-question`;
  return baseApiCall({
    url: url,
    method: 'put',
    data
  })
}
export const ApiReviewReport  = (data: any, clientGroup: any) => {
  const baseUrl = getApiBaseUrl(clientGroup);
  const url = `${baseUrl}api/v1/common/review-report`;
  return baseApiCall({
    url: url,
    method: 'post',
    data
  })
}
export const ApiReviewReport2  = (data: any, clientGroup: any) => {
  const baseUrl = getApiBaseUrl(clientGroup);
  const url = `${baseUrl}api/v1/common/review-report-v4`;
  return baseApiCall({
    url: url + data,
    method: 'get',
  
  })
}
export const ApiRefineText  = (data: any, clientGroup: any) => {
  const baseUrl = getApiBaseUrl(clientGroup);
  const url = `${baseUrl}api/v1/common/review-text`;
  return baseApiCall({
    url: url,
    data,
    method: 'post',
  
  })
}
export const ApiGetReportHistory  = (data: any, clientGroup: any) => {
  const baseUrl = getApiBaseUrl(clientGroup);
  const url = `${baseUrl}api/v1/report/get-report-history`;
  return baseApiCall({
    url: url + data,
    method: 'get',
  })
}

export const ApiGetPromoterConfig  = (data: any, clientGroup: any) => {
  const baseUrl = getApiBaseUrl(clientGroup);
  const url = `${baseUrl}api/v1/report/get-net-promoter-score-config`;
  return baseApiCall({
    url: url + data,
    method: 'get',
  })
}

export const ApiSubmitNetPromoterScore = (data: any, clientGroup: any) => {
  const baseUrl = getApiBaseUrl(clientGroup);
  const url = `${baseUrl}api/v1/report/submit-net-promoter-score`;
  return baseApiCall({
    url: url,
    method: 'post',
    data
  })
}

export const ApiDownloadScorecard  = (data: any, clientGroup: any) => {
  const baseUrl = getApiBaseUrl(clientGroup);
  const url = `${baseUrl}api/v1/report/mm-scorecard-pdf-download`;
  return baseApiCall({
    url: url + data,
    method: 'get',
    responseType: 'blob',
    fullResponse: true
  })
}
